import React from "react";
import OrderItemFormStore from "../OrderItemFormStore";
import { observer } from "mobx-react-lite";
import { Tag } from "antd";
import { ManualOrderItem } from "../type";
import { uuid } from "@/utils";
import { cloneDeep } from "lodash";

interface HistoryAddedManualOrderItemListProps {
    store: OrderItemFormStore;
}

const HistoryAddedManualOrderItemList: React.FC<HistoryAddedManualOrderItemListProps> = function (props) {
    const { store } = props;

    if (store.historyAddedManualOrderItemList.length === 0) return null;

    function handleAddHistoryManualOrderItem(manualOrderItem: ManualOrderItem) {
        const cloneManualOrderItem = cloneDeep(manualOrderItem);

        cloneManualOrderItem.key = uuid();

        cloneManualOrderItem.quantity = 1;

        store.addOrderItems([cloneManualOrderItem]);
    }

    return (
        <div className="mt10">
            <div className="text-gray fs14">这些是添加过的商品，可以点击直接选择</div>

            <div className="flex flex-wrap">
                {store.historyAddedManualOrderItemList.map((manualOrderItem, index) => {
                    const key = (manualOrderItem.title ?? "") + (manualOrderItem.skuProperties ?? "") + index;

                    return (
                        <Tag
                            variant="outlined"
                            key={key}
                            closable
                            className="cursor-pointer mt5"
                            style={{ marginRight: 8 }}
                            onClose={() => {
                                store.handleRemoveHistoryOrderItem(index);
                            }}
                            onClick={() => {
                                handleAddHistoryManualOrderItem(manualOrderItem);
                            }}
                        >
                            {manualOrderItem.title ? <span>{manualOrderItem.title}</span> : null}
                            {manualOrderItem.simpleTitle ? (
                                <span className="text-gray">({manualOrderItem.simpleTitle})</span>
                            ) : null}
                            {manualOrderItem.skuProperties ? (
                                <span className="error">({manualOrderItem.skuProperties})</span>
                            ) : null}
                        </Tag>
                    );
                })}
            </div>
        </div>
    );
};

export default observer(HistoryAddedManualOrderItemList);
